import "@fontsource/arbutus-slab/400.css";
import "@fontsource/almarai/400.css";
import "@fontsource/almarai/700.css";
import "@fontsource/libre-baskerville/400.css";
import "@fontsource/libre-baskerville/700.css";
import "./styles.css";
import { TerpeneQuizApp } from "./app";
import { loadLiveQuizConfig } from "./config/live";
import { mountQuizSettings } from "./settings";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("App root was not found.");

if (location.pathname === "/settings") {
  void mountQuizSettings(root);
} else {
  void loadLiveQuizConfig()
    .then(() => new TerpeneQuizApp(root).mount())
    .catch((error: unknown) => {
      root.textContent = error instanceof Error ? error.message : "Quiz settings could not be loaded.";
    });
}
